var handleArrangements = function() {
  function onChange(counter) {
    if (counter > 1) {
      $('.js-remove-arrangement').show()
    } else {
      $('.js-remove-arrangement').hide()
    }
  }
  var counter = 1;
  var template = $("#template-arrangement").html();
  $(document).on('click', '.js-add-arrangement', function () {
    var row = template;
    var current = $('#arrangement-' + counter);
    counter++;
    row = row.replace(/{number}/g, counter);
    current.after(row);
    onChange(counter);
  })
  $(document).on('click', '.js-remove-arrangement', function () {
    var current = $('#arrangement-' + counter);
    current.remove();
    counter--;
    onChange(counter);
  })
}

var handleFileUpload = function() {
  var inputs = document.querySelectorAll('#FileUpload');
  Array.prototype.forEach.call(inputs, function (input) {
    var label = input.nextElementSibling;
    var labelVal = label.innerHTML;

    input.addEventListener('change', function (e) {
      var fileName = '';
      if (this.files && this.files.length > 1)
        fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
      else
        fileName = e.target.value.split('\\').pop();
      label.nextElementSibling.innerHTML = fileName;
    });
  });
}

var handleSlideCollection = function() {
  var time = 500;

  var closeSlide = function ($slide, $parent) {
    $parent.animate({
      paddingBottom: 0
    }, time, function () {
      $(this).removeClass('opened');
    });
    $slide.animate({
      height: 0
    }, time);
  }

  var openSlide = function ($slide, $parent) {
    var h = $slide.get(0).scrollHeight;
    $parent.animate({ paddingBottom: h }, time, function() {
      $(this).addClass('opened');
    });
    $slide.animate({ height: h }, time, function() {
      $(this).height('auto');
      $('[data-product-slider]').trigger('updateSlider');
      $('html, body').animate({
        scrollTop: $parent.offset().top - $('.site-header').outerHeight() - 20
      }, time);
    });
  }

  // Main opening trigger
  $('.js-gift-product-item').click(function (e) {
    e.preventDefault();
    resetOptions();

    $('.js-gift-product-item').each(function (index, element) {
      var $parent = $(element).closest('.productgrid--item');
      var $slide = $parent.find('.slide-product');
      closeSlide($slide, $parent);
    });
    
    var $parent = $(this).closest('.productgrid--item');
    var $slide = $parent.find('.slide-product');
    if($parent.hasClass('opened')) {
      closeSlide($slide, $parent);
    } else {
      openSlide($slide, $parent);
    }
  })

  // Close button trigger
  $('.slide-product__close').click(function (e) {
    e.preventDefault();
    var $parent = $(this).closest('.productgrid--item');
    var $slide = $parent.find('.slide-product');
    closeSlide($slide, $parent);
  })
}

var handleDateTimePicker = function() {
  flatpickr(".js-date-time", {
    minDate: "today",
    enableTime: true,
    wrap: true,
    disableMobile: "true",
    onChange: function (selectedDates, dateStr, instance) {
      $(instance.element).find('.form-field-input').addClass('form-field-filled');
    },
  });
}

var handleBlockOptions = function() {
  // Locations
  function disablePickup() {
    $(".js-option-pickup-location input").val("").prop("disabled", "disabled").removeClass("form-field-filled");
  }
  function enablePickup() {
    $(".js-option-pickup-location input").removeAttr("disabled");
  }
  function disableDelivery() {
    $(".js-option-delivery-location input").val("").prop("disabled", "disabled").removeClass("form-field-filled");
  }
  function enableDelivery() {
    $(".js-option-delivery-location input").removeAttr("disabled");
  }
  $(".js-option-delivery-method select").change(function () {
    var v = $(this).val();
    if (v == "Drop your items and pick the wrapped gift later") {
      disablePickup();
      disableDelivery();
    } else if (v == "You drop your items and we deliver the wrapped gift 25 AED") {
      disablePickup();
      enableDelivery();
    } else {
      enablePickup();
      enableDelivery();
    }
  })

  // Size
  $(".js-option-size select").change(function() {
    if($(this).val() == "Own Box") {
      $(".js-option-own-box input").prop("checked", true);
      $(".js-option-size").hide();
    }
  })
  $(".form-field-checkbox").on("change", "#own-box", function () {
    if ( $(this).is(":checked") ) {
      $(".js-option-size select").val("Own Box").change();
      $(".js-option-size").hide();
    } else {
      $(".js-option-size select").val($(".js-option-size select option:first").val()).change();
      $(".js-option-size").show();
    }
  })
}

var resetOptions = function() {
  // Reset:
  $(".js-option-delivery-method select").val($(".js-option-delivery-method select option:first").val()).change();
  $(".js-option-size select").val($(".js-option-size select option:first").val()).change();
  $(".js-option-size").show();
  $(".js-option-own-box input").prop("checked", false);
}

var handleAdditionalItems = function () {
    var ITEMS_LIMIT = 5;

    function createItem(i) {
        return $('<div>', {
            class: 'product-form--atc',
            html:  $('<div>', {
                class: 'form-field item-property-wrapper',
                html:  [
                    $('<input>', {
                        id:           'item-' + i,
                        type:         'text',
                        class:        'form-field-input form-field-input--shadow item-property-field',
                        autocomplete: 'off',
                        name:         'properties[Item ' + i + ']',
                        required:     true
                    }),
                    $('<label>', {
                        class: 'form-field-title',
                        text:  i + '. Please describe your item'
                    }),
                    $('<span>', {
                        class: i < ITEMS_LIMIT ? 'add-item' : '',
                        text:  '+'
                    })
                ]
            })
        });
    }

    $(document).on('click', '.add-item',function (index, i) {
        var $plus_sign = $(this),
            id = $plus_sign.parents('.product-form--atc').find('.form-field-input').attr('id').split('-')[1],
            $itemsHolder = $('.additional-items'),
            $newItem = createItem(parseInt(id)+1);
        $(this).fadeOut('fast');
        if (parseInt(id) < ITEMS_LIMIT) {
            $itemsHolder.append($newItem);
        }
    });
}

var stringColor = {
  classes: {
    colorContainer: '.option_string-colors',
    chooseContainer: '.option_strings-base-color',
    select: '.option_strings-base-color select',
    selectHelium: '.js-option-helium select',
    loadClass: 'loaded'
  },

  init: function () {
    var self = this;

    self.colorContainer = $(self.classes.colorContainer);
    self.chooseContainer = $(self.classes.chooseContainer);
    self.selectHelium = $(self.classes.selectHelium);

    if (self.colorContainer.length == 0) return;

    self.getTemplate();
    self.load();

    self.selectHelium.on('change', function () {
      if ($(this).val() == 'yes') {
        self.showString();
      } else {
        self.hideString();
      }
    })
  },

  getTemplate: function () {
    this.chooseTemplate = this.chooseContainer.html();
    this.template = this.colorContainer.html();

    this.chooseContainer.empty();
    this.colorContainer
      .empty()
      .addClass(this.classes.loadClass);
  },

  load: function () {
    if (this.selectHelium.val() == 'yes') this.showString();
  },

  showString: function() {
    var self = this;

    if (!self.show) {
      self.chooseContainer.html(self.chooseTemplate);

      self.select = $(self.classes.select);

      if (this.select.val() == 'select your color') this.open()

      self.select.on('change', function () {
        if ($(this).val() == 'select your color') {
          self.open();
        } else {
          self.close();
        }
      });

      self.show = true;
    }
  },

  hideString: function() {
    if (this.show) {
      this.close();
      this.chooseContainer.empty();
      this.show = false;
    }
  },

  open: function () {
    if (!this.loaded) {
      this.colorContainer.html(this.template);
      this.loaded = true;
    }
  },

  close: function () {
    if (this.loaded) {
      this.colorContainer.empty();
      this.loaded = false;
    }
  }
}

var formValidate = (function (){
  var exp = {};
  var classes = {
    form: '.shopify-product-form',
    radio: '.option_string-colors input[type="radio"]',
    button: '.product-form--atc-button'
  };
  var data = {
    alertTemplate: "Please choose balloon's string color",
    alertTime: 2000
  };

  exp.init = function () {
    data.form = $(classes.form);
    data.button = $(classes.button);
    data.buttonTemplate = data.button.text();

    if (data.form.length == 0) return;

    data.button.on('click', function (e) {
      if (data.form.find(classes.radio).length == 0) return;
      var radioVal = data.form.find(classes.radio + ':checked').val();
      if (!radioVal) {
        e.preventDefault();
        showAlert();
      }     
    })
  };

  function showAlert () {
    data.button.text(data.alertTemplate);

    if (data.timer) clearTimeout(data.timer);
    data.timer = setTimeout(function () {
      data.button.text(data.buttonTemplate);
    }, data.alertTime)
  }

  return exp;
}());

var formData = (function () {
  var settings = {
    minDate: "today",
    enableTime: true,
    disableMobile: "true"
  };
  var target = '.form__data';

  return function () {
    if ($(target).length == 0) return;

    $(target).flatpickr(settings);
  }
}());

$(function () {
  handleFileUpload();
  handleSlideCollection();
  handleArrangements();
  handleDateTimePicker();
  handleBlockOptions();

  handleAdditionalItems();

  stringColor.init();
  formValidate.init();
  formData();
});